export default "__VITE_ASSET__BxPcya$Q__"